export interface AgentCommissionVersionDto {
    name: string
    agentCommission: AgentCommissionDto
    lastUpdatedDate: string
    lastUpdatedBy: string
    ratesFor?: string
    isCurrent?: boolean
}

export interface AgentCommissionDto {
    startDate: string 
    endDate?: string
    minChangeDate: string
    status: AgentCommissionStatus 
    countries: AgentCommissionCountryDto[]
    versionCode: string
    rules: AgentCommissionRuleDto[]
}

export interface SaveAgentCommissionDto {
    startDate: string
    endDate?: string
    countries: AgentCommissionCountryDto[]
}

export interface AgentCommissionCountryDto {
    countryId: string
    percentageRates: {[id: string]: string}
    schools: AgentCommissionSchoolDto[]
    allSchoolsSpecified: boolean
}

export interface AgentCommissionSchoolDto {
    schoolId: string
    percentageRates: {[id: string]: string}
}

export interface AgentCommissionRuleDto {
    code: string
    name: string
}

export enum AgentCommissionStatus {
    Active, 
    Expired, 
    FutureStart,
    New
}

export interface AgentCommissionRateQueryDto {
    versionCode: string, 
    schoolId?: string, 
    itemId?: string,
    itemType?: RateQueryItemType
}

export enum AgentCommissionRateQueryStatus {  
    Errored,
    Found
}

export interface AgentCommissionRateQueryResult {
    status: AgentCommissionRateQueryStatus,
    ruleId?: string, 
    locationId?: string, 
    locationType?: RateQueryLocationType, 
    rate?: string
}

export enum RateQueryLocationType
{
    school,
    country
}

export enum RateQueryItemType {
    fee, 
    product, 
}
